// ----------------------------------------------------------------------------
// Styles
export enum TagColor {
  Red = "red",
  Magenta = "magenta",
  Violet = "violet",
  LightGreen = "light_green",
  Green = "green",
  DarkGreen = "dark_green",
  Cyan = "cyan",
  Blue = "blue",
  DarkBlue = "dark_blue",
  Yellow = "yellow",
  Gray = "gray",
  Black = "black",
}
export enum StickyNoteColor {
  Gray = "gray",
  LightYellow = "light_yellow",
  Yellow = "yellow",
  Orange = "orange",
  LightGreen = "light_green",
  Green = "green",
  DarkGreen = "dark_green",
  Cyan = "cyan",
  LightPink = "light_pink",
  Pink = "pink",
  Violet = "violet",
  Red = "red",
  LightBlue = "light_blue",
  Blue = "blue",
  DarkBlue = "dark_blue",
  Black = "black",
}

export enum ShapeType {
  Rectangle = "rectangle",
  Circle = "circle",
  Triangle = "triangle",
  WedgeRoundRectangleCallout = "wedge_round_rectangle_callout",
  RoundRectangle = "round_rectangle",
  Rhombus = "rhombus",
  Parallelogram = "parallelogram",
  Star = "star",
  RightArrow = "right_arrow",
  LeftArrow = "left_arrow",
  Pentagon = "pentagon",
  Hexagon = "hexagon",
  Octagon = "octagon",
  Trapezoid = "trapezoid",
  FlowChartPredefinedProcess = "flow_chart_predefined_process",
  LeftRightArrow = "left_right_arrow",
  Cloud = "cloud",
  LeftBrace = "left_brace",
  RightBrace = "right_brace",
  Cross = "cross",
  Can = "can",
}

// ----------------------------------------------------------------------------
// Widgets
export enum ItemType {
  Text = "text",
  StickyNote = "sticky_note",
  Shape = "shape",
  Image = "image",
  Frame = "frame",
  Preview = "preview",
  Card = "card",
  USM = "usm",
  Kanban = "kanban",
  Document = "document",
  Mockup = "mockup",
  Curve = "curve",
  WebScreen = "webscreen",
  Table = "table",
  Svg = "svg",
  Emoji = "emoji",
  Embed = "embed",
  Connector = "connector",
  Opaque = "opaque",
  TableText = "table_text",
  RallyCard = "rallycard",
  Stencil = "stencil",
}

// ----------------------------------------------------------------------------
// Entities
export enum EntityType {
  Tag = "tag",
}
